import { FormControl } from 'baseui/form-control'
import getError from '@/containers/SubscriptionFormPageNew/getError'
import SDButtonGroup from '@/shared/components/SDComponentsNewDesign/SDButtonGroup/SDButtonGroup'
import useAddress from '@/containers/SubscriptionFormPageNew/Components/Address/useAddress'
import { mandatoryTag } from '@/containers/SubscriptionFormPageNew/isMandatory'

const ResidenceType = () => {
  const { residenceOptionsArray, showResidenceType, updateAddress, errors, t, residenceType, optionalResidenceFields } =
    useAddress()

  if (!showResidenceType) {
    return null
  }

  return (
    <FormControl
      label={() => (
        <div
          dangerouslySetInnerHTML={{
            __html: (optionalResidenceFields ? '' : mandatoryTag) + t('subscriptionForm:address_module.residence_type'),
          }}
        />
      )}
      error={getError('residenceType', errors)}
    >
      <SDButtonGroup
        onClickHandler={value => {
          updateAddress({ residenceType: value })
        }}
        options={residenceOptionsArray}
        selectedValue={residenceType}
        newTranslations={true}
        translationsPath='subscriptionForm:address_module.residence_types.'
      />
    </FormControl>
  )
}

export default ResidenceType
